import * as React from "react";
import * as kea from "kea-react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import * as L from "leaflet";
import { fa } from "typed-font-awesome";

export interface SucursalMapa {
    color: "naranja" | "gris" | "azul",
    coords: { lat: number, lng: number },
    nombre: string;
    direccion?: string;
    telefono1?: string;
    telefono2?: string;
    telefono3?: string;
};

const img = {
    blue: require("app/img/blue.png"),
    grey: require("app/img/grey.png"),
    orange: require("app/img/orange.png")
}

const sucursales: SucursalMapa[] = [
    {
        nombre: "Monterrey",
        direccion: "Centro de Distribución Plaza Jumbo, Bodega #10, Av. Churubusco y Francisco Beltrán, 64540 Monterrey, N.L.",
        telefono1: "(81) 8331 7292",
        telefono2: "(81) 8331 8327",
        telefono3: "(81) 8351 5439",
        color: "naranja",
        coords: {
            lat: 25.690615761955403,
            lng: -100.26931711420349
        }
    }, {
        nombre: "Guadalajara",
        direccion: "Calle 3 #1374, Bodega 4, Col. Colón Industrial, CP 44940, Guadalajara, Jalisco, Mx.",
        telefono1: "(33) 3619 0989",
        telefono2: "(33) 3619 4387",
        telefono3: "(33) 3619 8267",
        color: "naranja",
        coords: {
            lat: 20.6448756,
            lng: -103.3654979
        }
    }, {
        nombre: "Tepic",
        direccion: "Calle Teikame #21-A, Col. Mercado Nayarabastos, CP. 63173, Tepic, Nayarit, Mx.",
        telefono1: "(311) 133 7109",
        telefono2: "(311) 133 7112",
        telefono3: "(311) 133 7121",
        color: "naranja",
        coords: {
            lat: 21.475727727251837, 
            lng: -104.85887350679688
        }
    }, {
        nombre: "Mazatlán",
        direccion: "Carretera Internacional al norte Km 1.5, Col. El Venadillo, CP 82129, Mazatlán, Sinaloa, Mx.",
        telefono1: "(669) 1 35 2250",
        telefono2: "(669) 1 35 2251",
        telefono3: "(669) 1 35 2252",
        color: "naranja",
        coords: {
            lat: 23.2652691,
            lng: -106.4171759
        }
    }, {
        nombre: "Culiacán",
        direccion: "Industrias del Valle No. 2869 (Parque Industrial CANACINTRA 2). Col. San Rafael, CP. 80150 Culiacán, Sinaloa, Mx.",
        telefono1: "(667) 766 3187",
        telefono2: "(667) 766 3188",
        telefono3: "(667) 766 3207",
        color: "naranja",
        coords: {
            lat: 24.7772678,
            lng: -107.4357607
        }
    }, {
        nombre: "Los Mochis",
        direccion: "Centro de logística y distribución integral (LDI) locales C27-28, carretera México 15, CP. 81254 Los Mochis, Sinaloa, Mx.",
        telefono1: "(668) 819 8122",
        telefono2: "(668) 819 8123",
        telefono3: "(668) 819 8127",
        color: "naranja",
        coords: {
            lat: 25.816363,
            lng: -108.960603
        }
    }, {
        nombre: "Navojoa",
        direccion: "Sufragio Efectivo No. 423 Reforma, CP. 85830 Navojoa, Sonora, Mx.",
        telefono1: "(642) 422 5958",
        telefono2: "(642) 422 9881",
        telefono3: "(642) 422 8173",
        color: "naranja",
        coords: {
            lat: 27.0774419,
            lng: -109.4440536
        }
    }, {
        nombre: "Ciudad Obregón",
        direccion: "Jalisco No. 816-4 entre norte y cajeme. Col. Centro, CP. 85000 Cd. Obregón, Sonora, Mx.",
        telefono1: "(644) 4158 903",
        telefono2: "(644) 4156 569",
        telefono3: "(644) 4157 230",
        color: "naranja",
        coords: {
            lat: 27.5109358,
            lng: -109.9292936
        }
    }, {
        nombre: "Guaymas",
        direccion: "Calle Naranjo esquina con Calle Jaiba, S/N, Bodega 4, Colonia Guadalupe, Código postal 85440, Guaymas, Sonora, Mx.",
        telefono1: "(622) 222 5983",
        telefono2: "(622) 222 6418",
        telefono3: "(622) 222 6496",
        color: "naranja",
        coords: {
            lat: 27.924591573398445,
            lng: -110.9106310805133
        }
    }, {
        nombre: "Hermosillo",
        direccion: "Ave. José Ma. Mendoza No. 101 Col. El Llano, CP. 83214 Hermosillo, Sonora, Mx.",
        telefono1: "(662) 261 5150",
        telefono2: "(662) 261 5624",
        color: "naranja",
        coords: {
            lat: 29.1066762,
            lng: -110.9722253
        }
    },  {
        nombre: "Guasave",
        color: "naranja",
        direccion: "Av. Insurgentes s/n, esquina con Lázaro Cárdenas, Col. del Bosque, Guasave, Sinaloa, CP: 81040" ,
        telefono1:"(687) 3000701",
        coords: {
            lat: 25.5728832,
            lng: -108.4733516
        }
    }, {
        nombre: "Guamúchil",
        color: "gris",
        coords: {
            lat: 25.4604678,
            lng: -108.0796663
        }
    }, {
        nombre: "León",
        direccion:"Calle Torquito #103, Col. Plaza de toros, León, Guanajuato, CP 37457",
        telefono1:"(477) 1011596",
        color: "naranja",
        coords: {
            lat: 21.1010843,
            lng: -101.6930028
        }

    }, {
        nombre: "Aguascalientes",
        direccion: "Block C - bodega 25, Central de Abastos, CP 20280",
        telefono1: "(66) 8172 7624",
        color: "naranja",
        coords: {
            lat: 21.8314984,
            lng: -102.2916861
        }
    }, {
        nombre: "San Luis Potosi",
        color: "azul",
        coords: {
            lat: 22.144742,
            lng: -100.9746122
        }
    }, {
        nombre: "Nogales",
        direccion: "Retorno Libre Comercio Boulevard de Los Negocios, 12-A, Polígono P, Colonia Parque Industrial Nogales, Código Postal 84094 Nogales, Sonora, Mx.",
        color: "naranja",
        telefono1: "(631) 319 3798",
        coords: {
            lat: 31.253035740335683,
            lng: -110.96470206428438
        }
    }, {
        nombre: "Caborca",
        direccion: "Calle Obregón 271 entre R y S Col. Centro. Caborca, Sonora, Mx.",
        color: "naranja",
        telefono1: "(637) 372 5683",
        coords: {
            lat: 30.7097596,
            lng: -112.1744302
        }
    }, {
        nombre: "Magdalena de Kino",
        direccion: "Niños Heroes # 609 Local 3, Col. Mirasol Norte. CP 84160 Magdalena, Sonora, Mx.",
        color: "naranja",
        telefono1: "(632) 322 7010",
        coords: {
            lat: 30.6339616,
            lng: -110.9599494
        }
    }, {
        nombre: "Santa Ana",
        color: "gris",
        coords: {
            lat: 30.5436284,
            lng: -111.1222192
        }
    }, {
        nombre: "Cananea",
        color: "gris",
        coords: {
            lat: 30.982729,
            lng: -110.3018263
        }
    }, {
        nombre: "Imuris",
        color: "gris",
        coords: {
            lat: 30.777301,
            lng: -110.8616435
        }
    }, {
        nombre: "Altar",
        color: "gris",
        coords: {
            lat: 30.7158094,
            lng: -111.8347619
        }
    }, {
        nombre: "Pitiquito",
        color: "gris",
        coords: {
            lat: 30.6793066,
            lng: -112.0550368
        }
    }, {
        nombre: "Agua prieta",
        color: "gris",
        coords: {
            lat: 31.3281529,
            lng: -109.5478002
        }
    },
    {
        nombre:"San Francisco del Rincón",
        color:"gris",
        coords:{
            lat:21.0167938,  
            lng:-101.84924690000003
        }
    },
    {
        nombre:"Silao",
        color:"gris",
        coords:{
            lat:20.945147267840163, 
            lng:-101.42819398465576 
        }
    }
];


function getIcon(color: "orange" | "grey" | "blue") {
    return new L.Icon({
        iconUrl: 'app/img/' + color + '.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });
}

const iconos = {
    naranja: getIcon("orange"),
    gris: getIcon("grey"),
    azul: getIcon("blue")
};

export class MapaUruz extends React.PureComponent {

    onLlamar = async (telefono: string) => {
        //await kea.message("LLamar\nTODO:");
    }

    render() {
        return (
            <div >
                <Map center={[25.6182312, -105.6899689]} zoom={5} style={{ height: "375px" }} >
                    <TileLayer
                        attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {
                        sucursales.map(x =>
                            <Marker key={x.nombre} position={[x.coords.lat, x.coords.lng]} icon={iconos[x.color]}  >
                                <Popup>
                                    <span>
                                        <label>{x.nombre}</label>
                                        <br />
                                        <p style={{ color: "blue", fontSize: "12px", textAlign: "justify", fontFamily: "'Montserrat', sans-serif" }}>
                                            {
                                                x.color == "naranja" ? "" :
                                                    x.color == "gris" ? "Con servicio de entrega a domicilio" :
                                                        "Servicio próximamente"
                                            }
                                        </p>
                                        <p style={{ fontSize: "12px", textAlign: "justify", fontFamily: "'Montserrat', sans-serif" }}>
                                            {x.direccion}
                                            <br />
                                        </p>
                                        {
                                            (x.color == "naranja") &&
                                            <p style={{ fontSize: "12px", textAlign: "justify", fontFamily: "'Montserrat', sans-serif" }}>
                                                <br />
                                                <div style={{ fontSize: "12px", fontFamily: "'Montserrat', sans-serif" }} >
                                                    Teléfono: <br />
                                                    {
                                                        x.telefono1 &&
                                                        <div>
                                                            <a href={"tel:" + x.telefono1}> <i className={fa("phone")} /> {"  "} {x.telefono1} {"  "} Llamar</a>

                                                            <br />
                                                        </div>
                                                    }
                                                    {
                                                        x.telefono2 &&
                                                        <div>
                                                            <a href={"tel:" + x.telefono2}> <i className={fa("phone")} /> {"  "} {x.telefono2} {"  "} Llamar</a>
                                                            <br />
                                                        </div>
                                                    }
                                                    {
                                                        x.telefono3 &&
                                                        <div>
                                                            <a href={"tel:" + x.telefono3}> <i className={fa("phone")} /> {"  "} {x.telefono3} {"  "} Llamar</a>
                                                            <br />
                                                        </div>
                                                    }
                                                </div>
                                            </p>
                                        }
                                    </span>
                                </Popup>
                            </Marker >
                        )
                    }
                </Map>

                <div style={{ marginTop: "5%", flexWrap: "wrap", display: "flex", direction: "row", fontFamily: "'Montserrat', sans-serif" }}>

                    <div style={{ width: '100%', flexWrap: "wrap", display: "flex", direction: "column" }} >
                        <div style={{ width: "10%", textAlign: "center" }}>
                            <img src={img.orange}
                                style={{
                                    flex: "0 1 auto"
                                }}
                                width="45%"
                            />
                        </div>
                        <div style={{ width: "89%", fontSize: "16px", verticalAlign: "center" }}>
                            <div style={{ display: "inline-block", padding: "8px" }} >
                                Sucursal
                            </div>
                        </div>
                    </div>

                    <div style={{ width: '100%', flexWrap: "wrap", display: "flex", direction: "column" }} >
                        <div style={{ width: "10%", textAlign: "center" }}>
                            <img src={img.blue}
                                style={{
                                    flex: "0 1 auto"
                                }}
                                width="45%"
                            />
                        </div>
                        <div style={{ width: "89%", fontSize: "16px", verticalAlign: "center" }}>
                            <div style={{ display: "inline-block", padding: "8px" }} >
                                Contará con servicio próximamente
                            </div>
                        </div>
                    </div>

                    <div style={{ width: '100%', flexWrap: "wrap", display: "flex", direction: "column" }} >
                        <div style={{ width: "10%", textAlign: "center" }}>
                            <img src={img.grey}
                                style={{
                                    flex: "0 1 auto"
                                }}
                                width="45%"
                            />
                        </div>
                        <div style={{ width: "89%", fontSize: "16px", verticalAlign: "center" }}>
                            <div style={{ display: "inline-block", padding: "8px" }} >
                                Con servicio de entrega a domicilio
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/mapa.tsx